module.exports = __webpack_public_path__ + "static/media/community.d7d1f588.png";